export const SplitType = {
  ByPages: 0,
  ByTextPattern: 1,
  NoSplitting: 2
}
